(function() {
  'use strict';

  angular.module('soopkitchenApp').controller('PlanningProfileController', PlanningProfileController);

  PlanningProfileController.$inject = [ '$uibModalInstance', 'entity', 'Planning', 'parameters', 'SoopkitchenUtils' ];

  function PlanningProfileController($uibModalInstance, entity, Planning, parameters, SoopkitchenUtils) {
    var vm = this;
    vm.planning = entity;
    vm.group = parameters.group;
    vm.instrumentProfile = vm.planning.planResourcesProfile.experimentResourcesProfiles[vm.group];
    if (vm.instrumentProfile) {
        vm.powerMaxValue = vm.instrumentProfile.powerProfiles["TOTAL"].maxValue;
    }
    vm.valueRange   = 0;
    vm.startDate = new Date(vm.planning.validityStartTime.replace("Z", ""));
    vm.endDate = new Date(vm.planning.validityEndTime.replace("Z", ""));

    vm.volumeGroups = {};

    vm.clear = clear;
    vm.roundDecimals = roundDecimals;
    vm.calculateVolumes = calculateVolumes;

    init();
    calculateVolumes(vm.startDate, vm.endDate);
      function init() {
        if (!vm.instrumentProfile) {
          vm.currentInstrumentVolumes = Object.keys(vm.planning.planResourcesProfile.volumeProfiles);
        }
        else {
            vm.modulePowers = [];
            for ( var module in vm.instrumentProfile.powerProfiles) {
                if (module !== "TOTAL" || module.indexOf(vm.group) === 0) {
                    vm.modulePowers.push(module);
                }
            }
            vm.currentInstrumentVolumes = [];
            for ( var volume in vm.planning.planResourcesProfile.volumeProfiles) {
                if (volume.indexOf(vm.group) === 0) {
                    vm.currentInstrumentVolumes.push(volume);
                }
            }
        }
        vm.containsVolumes = vm.currentInstrumentVolumes.length > 0;
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    function roundDecimals(value) {
          return SoopkitchenUtils.roundDecimals(value, 3);
    }




      function calculateVolumes(startDate, endDate) {
          var specialVolumeNames = ["EUI_TAV_SSMM", "EUI_TAV_FLUSH", "PHI_TAV_SSMM", "PHI_TAV_FLUSH", "STIX_TAV", "RPW_TAV"];
          if (vm.currentInstrumentVolumes.length > 0) {
              for (var volumeName in vm.currentInstrumentVolumes) {
                  if (specialVolumeNames.includes(vm.currentInstrumentVolumes[volumeName])) {
                      var volumeData = {};
                      for (var endDateVol in vm.planning.planResourcesProfile.volumeProfiles[vm.currentInstrumentVolumes[volumeName]]["values"]) {
                          // endDateVol does not include ":ssZ" in some cases and "Z" in the rest. Where the format for the time is in the happenings HH:mm:ssZ
                          if (endDateVol.length === 16){
                              endDateVol = endDateVol + ":00";
                          }
                          endDateVol = endDateVol + "Z";
                          var happenings = vm.planning.observationInstanceTimeline.happenings;
                          var keyVolName = vm.currentInstrumentVolumes[volumeName];
                          var foundValue = 0;
                          for (var obser in happenings) {
                              if (happenings[obser]["endDate"] === (endDateVol)) {
                                  for (var volName in happenings[obser]["volumes"]) {
                                      if (volName === keyVolName) {
                                          foundValue = happenings[obser]["volumes"][volName];
                                          var foundStartDate = happenings[obser]["startDate"].replace("Z", "");
                                          var foundEndDate = happenings[obser]["endDate"].replace("Z", "");
                                          // Check if startDate key exists, if not, create an empty object
                                          if (!volumeData[foundStartDate]) {
                                              volumeData[foundStartDate] = {};
                                          }
                                          // Assign the value to the nested endDate key
                                          volumeData[foundStartDate][foundEndDate] = foundValue;
                                      }
                                  }
                              }
                          }
                      }
                      var totalVolume = 0;
                      totalVolume = generateVolumeGroups(volumeData, startDate, endDate, totalVolume);
              } else {
                  volumeData = vm.planning.planResourcesProfile.volumeProfiles[vm.currentInstrumentVolumes[volumeName]]["dataRatesTimes"];
                  totalVolume = 0;
                  totalVolume = generateVolumeGroups(volumeData, startDate, endDate, totalVolume);
              }
                  vm.volumeGroups[vm.currentInstrumentVolumes[volumeName]] = totalVolume;
              }
          }
      }

      function generateVolumeGroups(volumeData, startDate, endDate, totalVolume) {
          // Iterate over the volume data
          for (var startTime in volumeData) {
              for (var endTime in volumeData[startTime]) {
                  // Convert the date strings to Date objects
                  var startDateTime = new Date(startTime);
                  var endDateTime = new Date(endTime);

                  // Check if the volume falls within the date range
                  if (startDateTime >= startDate && endDateTime <= endDate) {
                      // Get the volume value
                      var volume = volumeData[startTime][endTime];
                      // Increment the total volume
                      totalVolume += volume;
                  } else if (startDateTime <= startDate && endDateTime <= endDate && endDateTime >= startDate) {
                      var overLapVol = calculateOverlapVolume(volumeData[startTime][endTime], startDateTime, endDateTime, startDate, endDateTime);
                      totalVolume += overLapVol;
                  } else if (startDateTime >= startDate && endDateTime >= endDate && startDateTime <= endDate) {
                      overLapVol = calculateOverlapVolume(volumeData[startTime][endTime], startDateTime, endDateTime, startDateTime, endDate);
                      totalVolume += overLapVol;
                  } else if (startDateTime <= startDate && endDateTime >= endDate) {
                      overLapVol = calculateOverlapVolume(volumeData[startTime][endTime], startDateTime, endDateTime, startDate, endDate);
                      totalVolume += overLapVol;
                  }
              }
          }
          return totalVolume;
      }

      function calculateOverlapVolume(volume, startDateTime, endDateTime, startDateOver, endDateOver) {
          var timeDifferenceInMinutes = (endDateTime - startDateTime) / (1000 * 60);
          var averageVolPerMinute = volume / timeDifferenceInMinutes;
          var overlappingMinutes = (endDateOver - startDateOver) / (1000 * 60);
          // Increment the total volume
          return averageVolPerMinute * overlappingMinutes;
      }


  }

})();
